/* @flow */

import { call, put, select, takeEvery } from 'redux-saga/effects'

import type { CustomerId } from '../types'

import { sagaGet } from '../fetch'

import { apiUrlForAutomatedPolls } from '../urls'

import {
  BadResponseError,
  SagaMalfunctionError,
  UnauthorizedError,
} from '../helpers'

import { selectCurrentUser } from '../stores/currentUser'
import { getSelectedCustomerId } from '../stores/ui/selectedCustomer'
import { isAdmin } from '../stores/usersStore'

import {
  selectNextUrlForUrl,
  intoCursoredUrlsStore,
} from '../stores/cursoredUrlsStore'

import {
  FETCH_AUTOMATED_POLLS,
  fetchAutomatedPollsSuccess,
  fetchAutomatedPollsError,
} from '../stores/polls/automated'

import { sagaLogoutUnauthorizedUser } from './logout'

export function* getTargetCustomer(): Generator<*, ?CustomerId, *> {
  const currentUser = yield select(selectCurrentUser)

  if (!currentUser) return null

  if (isAdmin(currentUser)) {
    return yield select(getSelectedCustomerId)
  }

  return currentUser.customerId
}

export function* sagaRepeatedlyFetchAutomatedPollsIntoStore(): Generator<
  *,
  void,
  *
> {
  yield takeEvery(
    [
      // explicit fetch
      FETCH_AUTOMATED_POLLS,
    ],
    sagaFetchAutomatedPollsIntoStore
  )
}

export function* sagaFetchAutomatedPollsIntoStore(): Generator<*, void, *> {
  try {
    const targetCustomer = yield getTargetCustomer()
    const nextUrl = yield select(selectNextUrlForUrl, 'automated-polls')
    const response = yield call(
      sagaGet,
      nextUrl || apiUrlForAutomatedPolls(targetCustomer)
    )
    if (response == null) throw new SagaMalfunctionError()
    if (response.status === 401 || response.status === 403) {
      yield call(sagaLogoutUnauthorizedUser)
      throw new UnauthorizedError()
    }
    if (response.status === 404) return
    if (response.status !== 200) throw new BadResponseError(response)

    const json = yield call([response, response.json])
    if (json == null) throw new SagaMalfunctionError()

    const { results, next } = json

    yield put(fetchAutomatedPollsSuccess(results))
    yield put(intoCursoredUrlsStore('automated-polls', next))
  } catch (error) {
    yield put(fetchAutomatedPollsError(error))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/fetchAutomatedPolls.js